<app-simple-search-select-value-accessor label="Opiekun zlecenia"
                                         [formControl]="supervisorForm"
                                         [searchFunction]="supervisorSearchFunction"
                                         [findById]="supervisorFindByIdFunction"
                                         [required]="required"
                                         [minLength]="2">
</app-simple-search-select-value-accessor>
